/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import { ArrowLeft } from 'lucide-react';
import { messagesApi } from '../../../api';

const MessageDetailPage = ({ sess = { uid: '', role: 'user' } }) => {
  const { messageId } = useParams();
  const navigate = useNavigate();
  const [messageData, setMessageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchMessageDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageId]);

  const fetchMessageDetails = async () => {
    try {
      const response = await messagesApi.getDetails(messageId);
      const data = response?.data?.data || response?.data;
      if (data) {
        setMessageData(data);
        setError('');
      } else {
        setError('Message not found');
      }
    } catch (err) {
      setError('Failed to load message');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date
      .toLocaleString('en-US', {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: 'Asia/Kolkata',
      })
      .replace(/,/g, '');
  };

  const DetailRow = ({ label, value }) => (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={4}>
        <Typography variant="subtitle2" color="text.secondary">
          {label}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={8}>
        <Typography variant="body2">{value || 'N/A'}</Typography>
      </Grid>
    </Grid>
  );

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error || !messageData) {
    return (
      <Box sx={{ textAlign: 'center', p: 4 }}>
        <Typography color="error" sx={{ mb: 2 }}>
          {error || 'Message not found'}
        </Typography>
        <Button variant="contained" onClick={() => navigate('/messages')}>
          Back to Messages
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      <Stack direction="row" alignItems="center" spacing={1} mb={2}>
        <Button variant="outlined" startIcon={<ArrowLeft size={16} />} onClick={() => navigate('/messages')}>
          Back
        </Button>
        <Typography variant="h5">Message Details</Typography>
      </Stack>

      <Card>
        <CardContent>
          <Stack spacing={2}>
            <DetailRow label="From" value={messageData.from} />
            <DetailRow label="To" value={messageData.to} />
            <DetailRow label="Status" value={messageData.status} />
            <DetailRow label="Date" value={formatDate(messageData.createdAt)} />
            <DetailRow label="Message" value={messageData.message || 'No message content'} />
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default MessageDetailPage;
